import { GetInfo } from 'ontime-types';

export const ontimePlaceholderInfo: GetInfo = {
  networkInterfaces: [],
  version: '4.0.0',
  serverPort: 4001,
  publicDir: '',
};
